// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3c117684","670":"c88b24e1","974":"e5c26c3e"}[chunkId] + ".chunk.js";
};